export interface Product {
  id: string;
  name: string;
  description: string;
  longDescription: string;
  price: number;
  originalPrice?: number;
  category: string;
  gender?: "donna" | "uomo" | "unisex";
  subCategory?: string;
  colors?: string[];
  brand?: string;
  image: string;
  images?: string[];
  rating: number;
  reviews: number;
  badge?: "SALE" | "NEW" | "BEST SELLER";
  inStock: boolean;
  featured?: boolean;
  sizes?: string[];
  material?: string;
  stock?: number;
}

export const categories = [
  {
    id: "donna",
    label: "Donna",
    desc: "Femminilità senza confini",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-8.png",
  },
  {
    id: "uomo",
    label: "Uomo",
    desc: "Eleganza maschile contemporanea",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-4_a286bbbe-0749-45be-b825-3c0bb2da8245.png",
  },
  {
    id: "accessori",
    label: "Accessori",
    desc: "Il dettaglio che fa la differenza",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-10.png",
  },
  {
    id: "scarpe",
    label: "Scarpe",
    desc: "Ogni passo, un capolavoro",
    image: "https://brupa.it/cdn/shop/files/Progetto_senza_titolo-9.png",
  },
];

export const products: Product[] = [
  {
    id: "1",
    name: "Abito in Seta Milano",
    description: "Seta pura, taglio sartoriale, eleganza assoluta",
    longDescription:
      "Realizzato in seta pura al 100% proveniente da Como. Il taglio sartoriale valorizza la silhouette con linee fluide e precise. Chiusura con zip invisibile sul retro. Disponibile in avorio, nero e burgundy. Ogni capo è numerato e accompagnato da certificato di autenticità.",
    price: 890,
    originalPrice: 1100,
    category: "donna",
    gender: "donna",
    subCategory: "abiti",
    colors: ["avorio", "nero", "bordeaux"],
    brand: "Eleventy",
    image: "https://brupa.it/cdn/shop/files/247631-1034_39d7299f-4ce8-4417-97ee-c4f0f0a7e1e9.webp",
    images: [
      "https://brupa.it/cdn/shop/files/247631-1034_2_fd3b8b7a-6ffd-472f-9582-b009b3cce637.webp",
      "https://brupa.it/cdn/shop/files/259337-1348_7991e79b-ed3f-4792-9b32-b11bb567bb9e.webp",
      "https://brupa.it/cdn/shop/files/246235-1442_8cb59135-475e-48be-86cf-956e7963159a.webp",
    ],
    rating: 4.9,
    reviews: 87,
    badge: "SALE",
    inStock: true,
    featured: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "100% Seta pura",
    stock: 2,
  },
  {
    id: "2",
    name: "Cappotto Cashmere Nero",
    description: "Cashmere mongolico di prima qualità, taglio oversize",
    longDescription:
      "Cappotto in cashmere puro proveniente dalla Mongolia, filato a mano e tinto con pigmenti naturali. Il taglio oversize garantisce comfort senza compromettere l'eleganza. Fodera in seta. Un investimento destinato a durare decenni.",
    price: 1290,
    category: "donna",
    gender: "donna",
    subCategory: "cappotti",
    colors: ["nero", "cammello"],
    brand: "Herno",
    image: "https://brupa.it/cdn/shop/files/257056-1387_5da1c6a8-c1e0-4a89-9ce6-0e67b960595f.webp",
    images: [
      "https://brupa.it/cdn/shop/files/257056-1387_2_899ad92e-9ea8-43e6-a43e-8af88753b72a.webp",
      "https://brupa.it/cdn/shop/files/257054-1022_a711b443-77dd-49b2-998b-d3bf7ec91d78.webp",
    ],
    rating: 4.8,
    reviews: 54,
    badge: "NEW",
    inStock: true,
    featured: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "100% Cashmere mongolico",
  },
  {
    id: "3",
    name: "Gonna Plissettata in Crêpe",
    description: "Movimento eterno, eleganza discreta",
    longDescription:
      "Gonna midi in crêpe di seta con plissettatura permanente a caldo. La caduta fluida si adatta a ogni silhouette. Chiusura laterale con zip nascosta. Perfetta abbinata a una blusa basic o un blazer strutturato.",
    price: 420,
    category: "donna",
    gender: "donna",
    subCategory: "gonne",
    colors: ["nero", "avorio", "cipria"],
    brand: "Dondup",
    image: "https://brupa.it/cdn/shop/files/256177-1032_fc42f8c9-482a-4c0c-996c-3062fd1079ec.webp",
    images: [
      "https://brupa.it/cdn/shop/files/256177-1032_2_75cf29a1-7d42-4a65-8d96-2df6da2de86e.webp",
    ],
    rating: 4.7,
    reviews: 132,
    originalPrice: 590,
    badge: "BEST SELLER",
    inStock: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "100% Crêpe di seta",
  },
  {
    id: "4",
    name: "Top in Maglia Cashmere",
    description: "Morbidezza estrema, stile minimalista",
    longDescription:
      "Top in maglia fine di cashmere puro, collo a V ribassato e maniche a tre quarti. La leggerezza del filato garantisce comfort dalla mattina alla sera. Disponibile in 6 colori essenziali: avorio, nero, caramello, grigio cenere, cipria, navy.",
    price: 380,
    category: "donna",
    gender: "donna",
    subCategory: "maglieria",
    colors: ["avorio", "nero", "caramello", "grigio", "cipria", "navy"],
    brand: "Eleventy",
    image: "https://brupa.it/cdn/shop/files/254081-1022.webp",
    images: [
      "https://brupa.it/cdn/shop/files/254081-1022_2.webp",
    ],
    rating: 4.6,
    reviews: 203,
    inStock: true,
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "100% Cashmere",
  },
  {
    id: "5",
    name: "Blazer Lana Vergine",
    description: "Sartoria italiana, vestibilità impeccabile",
    longDescription:
      "Blazer monopetto in lana vergine Super 150s proveniente dal Biellese. Fodera in cupro, asole lavorate a mano, bottoni in corno naturale. Il taglio slim valorizza la figura senza costringere. Ideale dal boardroom all'aperitivo.",
    price: 980,
    category: "uomo",
    gender: "uomo",
    subCategory: "blazer",
    colors: ["navy", "grigio", "nero"],
    brand: "BOSS",
    image: "https://brupa.it/cdn/shop/files/263218-1223_4afb5a29-448f-4ee5-8ef3-053dc869eb65.webp",
    images: [
      "https://brupa.it/cdn/shop/files/263218-1223_2_80eea656-9a73-497b-91dd-25e7285dc2cb.webp",
      "https://brupa.it/cdn/shop/files/261684-1022_773979d2-64be-4169-92e1-0f522e132de6.webp",
      "https://brupa.it/cdn/shop/files/261684-1022_2_ee84dcf9-fb9f-47c1-9c4f-be5f15cadc16.webp",
    ],
    rating: 4.9,
    reviews: 76,
    badge: "BEST SELLER",
    inStock: true,
    featured: true,
    sizes: ["44", "46", "48", "50", "52", "54"],
    material: "Lana vergine Super 150s",
    stock: 1,
  },
  {
    id: "6",
    name: "Camicia Oxford Popeline",
    description: "Il classico reinventato con tessuti premium",
    longDescription:
      "Camicia in popeline di cotone egiziano a doppio filo, bianchissimo naturale. Collo italiano, polsini doppi per gemelli, cuciture a tre fili. La vestibilità slim fit è studiata per chi porta la cravatta ma anche per chi la lascia aperta.",
    price: 280,
    category: "uomo",
    gender: "uomo",
    subCategory: "camicie",
    colors: ["bianco", "azzurro", "grigio"],
    brand: "Tommy Hilfiger",
    image: "https://brupa.it/cdn/shop/files/235114-1045_308bae51-bf1f-4652-a533-f75c7d82c0d7.webp",
    images: [
      "https://brupa.it/cdn/shop/files/235114-1045_2_48970887-a589-45d6-a557-3318872bf2de.webp",
    ],
    rating: 4.7,
    reviews: 189,
    inStock: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    material: "100% Cotone egiziano",
  },
  {
    id: "7",
    name: "Pantaloni Sartoriali Milano",
    description: "Taglio sartoriale, tessuto tecnico premium",
    longDescription:
      "Pantaloni a vita media in lana fresca tecnica Loro Piana. La costruzione sartoriale con pences garantisce una vestibilità superiore. Tasca america, tasca a pistagna, passanti per cintura. Struttura interna termoadesiva senza cuciture.",
    price: 520,
    category: "uomo",
    gender: "uomo",
    subCategory: "pantaloni",
    colors: ["grigio", "blu", "nero"],
    brand: "Dondup",
    image: "https://brupa.it/cdn/shop/files/262191-1059_b402d385-cff9-42d2-8f7b-626b5084efc7.webp",
    images: [
      "https://brupa.it/cdn/shop/files/262191-1059_2_b6acdfb-6dd3-4116-bd96-cf24a4160ce1.webp",
    ],
    rating: 4.8,
    reviews: 94,
    badge: "NEW",
    inStock: true,
    sizes: ["44", "46", "48", "50", "52", "54"],
    material: "Lana fresca Loro Piana",
  },
  {
    id: "8",
    name: "Trench Premium Impermeabile",
    description: "Iconico, impermeabile, intramontabile",
    longDescription:
      "Trench in gabardine di cotone trattato con tecnologia DWR di nuova generazione. Fodero in tartan di lana vergine. Il doppio petto con spalline rimovibili rende il capo versatile in tutte le stagioni. Certificato Oeko-Tex Standard 100.",
    price: 1150,
    category: "uomo",
    gender: "uomo",
    subCategory: "cappotti",
    colors: ["beige", "nero"],
    brand: "Herno",
    image: "https://brupa.it/cdn/shop/files/257426-1176_0637454e-c71c-4b12-a195-38cb95a9ecb0.webp",
    images: [
      "https://brupa.it/cdn/shop/files/257426-1176_2_13838ce6-707a-4450-9a5a-1017d2a620c4.webp",
    ],
    originalPrice: 1490,
    rating: 4.8,
    reviews: 61,
    inStock: true,
    sizes: ["S", "M", "L", "XL", "XXL"],
    material: "Gabardine cotone DWR",
  },
  {
    id: "9",
    name: "Borsa in Pelle Strutturata",
    description: "Pelletteria artigianale toscana, forma senza tempo",
    longDescription:
      "Borsa a mano in pelle di vitello pieno fiore conciata al vegetale a Firenze. Il rigido interno mantiene la forma nel tempo. Apertura con fermalio in ottone satinato, tasca interna zippata. Il colore scuro invecchia splendidamente, acquistando carattere.",
    price: 650,
    category: "accessori",
    gender: "donna",
    subCategory: "borse",
    colors: ["nero", "cognac", "bordeaux"],
    brand: "Dsquared2",
    image: "https://brupa.it/cdn/shop/files/253747-1032_de791a21-be96-4698-af26-a39e3917410f.webp",
    images: [
      "https://brupa.it/cdn/shop/files/253747-1032_2_1d8a4ce8-5bc9-4b89-9730-deb2e082542b.webp",
      "https://brupa.it/cdn/shop/files/238004-1188_b27967fb-ace9-45fd-9631-12aec4f39c71.webp",
      "https://brupa.it/cdn/shop/files/238004-1188_2_58df7a7a-7c8e-4a20-b83b-97b406ba8b8d.webp",
    ],
    rating: 4.9,
    reviews: 112,
    badge: "NEW",
    inStock: true,
    featured: true,
    material: "Pelle di vitello conciata al vegetale",
  },
  {
    id: "10",
    name: "Foulard in Seta Stampata",
    description: "Arte tessile in 90x90 cm di pura seta",
    longDescription:
      "Foulard in twill di seta pura 70g. Il motivo esclusivo, disegnato a mano da un artista italiano, è stampato con inchiostri a base d'acqua. Orlo arrotolato a mano, 3 mm. Un oggetto d'arte da indossare in mille modi.",
    price: 320,
    originalPrice: 450,
    category: "accessori",
    gender: "donna",
    subCategory: "foulard",
    colors: ["multicolor"],
    brand: "Eleventy",
    image: "https://brupa.it/cdn/shop/files/259277-1030_747264a3-50bc-4e77-8e66-466ec7a470eb.webp",
    images: [
      "https://brupa.it/cdn/shop/files/259277-1030_2_67148d3f-c54c-4b44-8df1-75577d03a6d2.webp",
    ],
    rating: 4.8,
    reviews: 148,
    badge: "SALE",
    inStock: true,
    material: "Twill di seta pura 70g",
  },
  {
    id: "11",
    name: "Cintura in Pelle Intrecciata",
    description: "Intreccio artigianale, fibbia in ottone massiccio",
    longDescription:
      "Cintura in pelle di vitello intrecciata a mano da artigiani di Firenze. Fibbia in ottone massiccio lucidato. Spessore 3,5 cm. La lavorazione a intreccio garantisce elasticità naturale e lunga durata. Disponibile in nero, marrone cognac, verde salvia.",
    price: 195,
    category: "accessori",
    gender: "unisex",
    subCategory: "cinture",
    colors: ["nero", "cognac", "verde"],
    brand: "BOSS",
    image: "https://brupa.it/cdn/shop/files/258001-1022_19a815c8-0525-4cc9-92ee-3621cc94b8c3.webp",
    images: [
      "https://brupa.it/cdn/shop/files/258001-1022_2_cb146002-0e56-4d68-a2b2-4f8262475cff.webp",
    ],
    rating: 4.7,
    reviews: 89,
    inStock: true,
    material: "Pelle di vitello intrecciata",
  },
  {
    id: "12",
    name: "Décolleté in Velluto",
    description: "Velluto di seta, tacco stiletto 9 cm",
    longDescription:
      "Scarpa décolleté in velluto di seta con punta affusolata e tacco stiletto da 9 cm in metallo laccato. Soletta in pelle di capra imbottita. Sottopiede antiscivolo. Ogni paio è cucito a mano nello stabilimento di Vigevano.",
    price: 580,
    category: "scarpe",
    gender: "donna",
    subCategory: "décolleté",
    colors: ["nero", "bordeaux", "nude"],
    brand: "Dsquared2",
    image: "https://brupa.it/cdn/shop/files/259419-1072_1857b87d-b4d1-401d-a092-1cb3a207ffdb.webp",
    images: [
      "https://brupa.it/cdn/shop/files/259419-1072_2_a0ce8824-7da0-490f-a6ea-94e80093d70e.webp",
    ],
    rating: 4.8,
    reviews: 67,
    badge: "NEW",
    inStock: true,
    sizes: ["35", "36", "37", "38", "39", "40", "41"],
    material: "Velluto di seta, suola in cuoio",
  },
  {
    id: "13",
    name: "Oxford in Cuoio Italiano",
    description: "Blake stitch, cuoio di vitello florentino",
    longDescription:
      "Oxford classico costruito con tecnica Blake stitch per una suola sottile ed elegante. Tomaia in cuoio di vitello florentino full grain. Soletta imbottita in pelle. La suola in cuoio con bordino in contrasto è sostituibile. Un classico che migliora col tempo.",
    price: 450,
    category: "scarpe",
    gender: "uomo",
    subCategory: "oxford",
    colors: ["cognac", "nero"],
    brand: "BOSS",
    image: "https://brupa.it/cdn/shop/files/260627-1265_0438d240-0241-43e9-8298-4cd7dd6adafd.webp",
    images: [
      "https://brupa.it/cdn/shop/files/260627-1265_2_9c380023-3646-49fc-8f87-90d072e82f2b.webp",
      "https://brupa.it/cdn/shop/files/261470-1023_e995f6c6-324b-4a27-915f-d0f36d89df8d.webp",
    ],
    rating: 4.9,
    reviews: 134,
    badge: "BEST SELLER",
    inStock: true,
    featured: true,
    sizes: ["39", "40", "41", "42", "43", "44", "45"],
    material: "Cuoio vitello florentino full grain",
    stock: 3,
  },
  {
    id: "14",
    name: "Stivali Chelsea in Pelle",
    description: "Elastici laterali, suola in gomma vulcanizzata",
    longDescription:
      "Chelsea boot in pelle liscia di vitello nero con elastici laterali in tessuto stretch. Punta leggermente appuntita, tacco a blocco da 4 cm. Suola in gomma vulcanizzata antiscivolo. Costruzione Goodyear welt per massima durata.",
    price: 720,
    category: "scarpe",
    gender: "donna",
    subCategory: "stivali",
    colors: ["nero", "cognac"],
    brand: "Diesel",
    image: "https://brupa.it/cdn/shop/files/239700-1026_03d5c061-569e-4ca2-bf5a-83af207681d7.webp",
    images: [
      "https://brupa.it/cdn/shop/files/239700-1026_2_b1ade350-8df7-4d86-a7bd-c95d71d59b8f.webp",
    ],
    originalPrice: 980,
    rating: 4.8,
    reviews: 201,
    inStock: true,
    sizes: ["36", "37", "38", "39", "40", "41"],
    material: "Pelle di vitello, suola gomma vulcanizzata",
  },
  {
    id: "15",
    name: "Sneakers Minimal in Pelle",
    description: "Design pulito, lusso quotidiano",
    longDescription:
      "Sneaker low-top in pelle di agnello nappa bianco ottico. Suola in gomma microcellulare ultraleggera. Linguetta imbottita, lacci piatti in cotone. La tomaia è cucita con filo di poliestere waxed per durare nel tempo. Il bianco è trattato con protezione anti-macchia.",
    price: 380,
    category: "scarpe",
    gender: "unisex",
    subCategory: "sneakers",
    colors: ["bianco", "nero"],
    brand: "Diesel",
    image: "https://brupa.it/cdn/shop/files/227767-1023_a9102880-a233-4e77-9938-8ded1dfad0dd.webp",
    images: [
      "https://brupa.it/cdn/shop/files/227767-1023_2_8b9ae92a-0911-4b69-9ba1-204b9ce5c7f6.webp",
      "https://brupa.it/cdn/shop/files/259440-1064_1de160df-796c-4fa9-b499-95d9166f6874.webp",
    ],
    rating: 4.6,
    reviews: 312,
    inStock: true,
    sizes: ["36", "37", "38", "39", "40", "41", "42", "43", "44", "45"],
    material: "Pelle di agnello nappa",
  },
  {
    id: "16",
    name: "Occhiali da Sole in Titanio",
    description: "Montatura in titanio, lenti minerali polarizzate",
    longDescription:
      "Montatura ultraleggera in titanio grado 5 da aviazione: pesa solo 18 grammi. Lenti in vetro minerale con trattamento polarizzato e anti-riflesso. Astine con inserto in acetato tartarugato. Astuccio rigido in pelle e panno microfibra inclusi.",
    price: 485,
    category: "accessori",
    gender: "unisex",
    subCategory: "occhiali",
    colors: ["oro", "nero"],
    brand: "Tommy Hilfiger",
    image: "https://brupa.it/cdn/shop/files/261521-1022_c8dc6c7b-121d-4f44-825d-9a5a5f78b7f8.webp",
    images: [
      "https://brupa.it/cdn/shop/files/261521-1022_2_bc028adb-3966-4abc-8a74-8bcae50bcf9c.webp",
    ],
    badge: "NEW",
    rating: 4.7,
    reviews: 78,
    inStock: true,
    material: "Titanio grado 5, lenti minerali",
  },
];

export function getProductById(id: string): Product | undefined {
  return products.find((p) => p.id === id);
}

export function getProductsByCategory(category: string): Product[] {
  return products.filter((p) => p.category === category);
}

export function getFeaturedProducts(): Product[] {
  return products.filter((p) => p.featured);
}
